import React from "react";
import SingleOrganizationContent from "../components/organizations/single-organization-content";

const SingleOrganization = () => {
  return <SingleOrganizationContent />;
};

export default SingleOrganization;
